// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"a6bd3609","862":"3a5c8344"}[chunkId] + ".chunk.css";
};